import { render, staticRenderFns } from "./PublicationsProduction.vue?vue&type=template&id=63b4fb73&scoped=true"
import script from "./PublicationsProduction.vue?vue&type=script&lang=js"
export * from "./PublicationsProduction.vue?vue&type=script&lang=js"
import style0 from "./PublicationsProduction.vue?vue&type=style&index=0&id=63b4fb73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b4fb73",
  null
  
)

export default component.exports